import { useState } from "react";

export const faqs = [
  {
    question: "PVC ou aluminium : que choisir pour mon tablier ?",
    answer:
      "Le PVC est léger, économique et offre une bonne isolation thermique. Il convient aux fenêtres de taille standard. L'aluminium est plus robuste, plus durable et résiste mieux aux grandes dimensions et aux vents forts. Il est idéal pour les baies vitrées larges. Notre technicien vous conseille sur place en fonction de la taille de votre baie, de l'exposition au vent et de votre budget.",
  },
  {
    question: "Peut-on changer juste quelques lames sans remplacer tout le tablier ?",
    answer:
      "Oui, si le dommage est localisé et que le reste du tablier est en bon état. Nous remplaçons uniquement les lames cassées, tordues ou percées par des lames neuves de même dimension et même matériau. C'est une solution plus rapide et plus économique que le remplacement complet du tablier. Nous vérifions toutefois que les axes d'articulation sont intacts.",
  },
  {
    question: "Combien de temps dure le remplacement d'un tablier ?",
    answer:
      "Le remplacement de quelques lames dure généralement moins d'une heure. Le remplacement complet d'un tablier prend entre une et deux heures selon la taille de la baie et l'accessibilité du coffre. Le calibrage et les tests de fonctionnement sont inclus dans le temps d'intervention.",
  },
  {
    question: "Quel est le prix du remplacement d'un tablier ?",
    answer:
      "Le prix dépend de la surface du tablier, du matériau choisi (PVC ou aluminium), du type de lames (standard ou isolées) et de l'ampleur des travaux. Nous établissons un devis gratuit et transparent sur place avant toute intervention. Il n'y a aucun frais caché et vous êtes libre d'accepter ou de refuser.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes — remplacement de tablier
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
              >
                <span className="text-[#143A66] text-base font-semibold">{faq.question}</span>
                <span className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-[#00B3A4] text-xl transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-[#2F4A63] text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}